export default async ({ app, redirect, $sentry }, inject) => {
  inject('sentryErrors', sentryErrors)

  if (process.browser) {
    if ($sentry) {
      console.log('Sentry is initialized 🧲')
      thisSentry = $sentry
    } else {
      console.log('Sentry is not initialized 🚨')
    }
  }
}

let thisSentry = null
export const sentryErrors = (err, apiName) => {
  let errorMessage

  if (err instanceof Error) {
    errorMessage = err.message
  } else if (typeof err === 'object' || Array.isArray(err)) {
    try {
      errorMessage = JSON.stringify(err)
    } catch (e) {
      errorMessage = `[Sentry Error Handler] Could not stringify object: ${e.message}`
    }
  } else {
    errorMessage = String(err)
  }

  if (thisSentry) {
    thisSentry.captureException(new Error(errorMessage), { extra: { apiName, errorMessage } })
    console.log('Sentry error captured 🧲')
  } else {
    console.error('Sentry is not initialized or accessible.', new Error(errorMessage))
  }
}
